export default "__VITE_ASSET__KS2Wd6CN__"